import React, { Component, createRef } from 'react';
import { withStyles, Card, CardMedia, CardContent, CardActions, Tooltip, IconButton, Button} from '@material-ui/core';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { ADD_POST, REMOVE_POST, UPDATE_POST, USER_INFO_FORM_DISMISSED, USER_INFO_FORM_SUBMISSION } from '../../core/handlers.actions';
import { IPost } from '../../core/models/post';
import { User } from '../../core/models/user';
// import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import CancelIcon from '@material-ui/icons/Cancel';
import InsertPhotoIcon from '@material-ui/icons/InsertPhoto';
import { TrixEditor } from 'react-trix';
import 'trix/dist/trix';
import  'trix/dist/trix.css';
import ContactInfo from '../forms/contact';

const styles = (theme: any) => ({
    root: { maxWidth: 250, width: 250},
    cancelIcon: {
        position: 'absolute' as any,
        top: '20px',
        right: '15px'
    },
    cancelIconPost: {
        position: 'absolute' as any,
        top: '0px',
        right: '0px'
    },
    removeImage: {
        position: 'absolute' as any,
        top: '0px',
        right: '0px'
    },
    uploadIcon: {
        position: 'absolute' as any,
        right: 25
    },
    actionArea: {
        marginTop: 25
    },
    postTitle: {
        fontWeight: 'bold' as any
    },
    imageHolder: {
        position: 'relative' as any
    },
    postStoryBtn: {
        padding: '7px 10px'
    }
});

interface Props {
    action: () => void;
    addPost: (data: any) => void,
    updatePost: (data: any) => void,
    deletePost: (id: string) => void,
    getPost: (id: any, posts: any) => IPost | boolean;
    post?: IPost | null;
    classes: any;
    posts: [IPost];
    tagsRef: any;
    featuredTag: any;
    tags: any;
    user: User;
    edit: boolean;
    layout?:any;
    needsApproval?:boolean;
    requiresUserContactInfo?: string;
    contactForm:any;
    dismissForm: () => void;
    submitForm: (data:any) => void;
}

interface State {
    image: string | null;
    title: string | null;
    description: string | null;
    isTruncated: boolean;
    imageErrorMessage: boolean;
    layout: number;
    isNewImage: boolean;
    removeImage: boolean;
    _id: string | null;
    postImage: string | null;
}

class PostAddEdit extends Component<Props, State> {
    postTitleElement = createRef<any>();
    state: State = {
        image: null,
        layout: 1,
        title: '',
        description: '',
        isTruncated: false,
        imageErrorMessage: false,
        isNewImage: false,
        _id: null,
        postImage: null,
        removeImage: false
    };

    textEditorControls: any = ['title', 'bold', 'italic', 'underline', 'strikethrough', 'highlight', 'undo', 'redo'];

    constructor(props: Props) {
        super(props);
        this.routeLayout = this.routeLayout.bind(this);
        this.titleMediaBody = this.titleMediaBody.bind(this);
        this.mediaTitleBody = this.mediaTitleBody.bind(this);
        this.titleBodyMedia = this.titleBodyMedia.bind(this);
        this.uploadImage = this.uploadImage.bind(this);
        this.inputHandleChange = this.inputHandleChange.bind(this);
        this.layoutHandle = this.layoutHandle.bind(this);
        this.uploadPostHandler = this.uploadPostHandler.bind(this);
        this.truncateHandler = this.truncateHandler.bind(this);
        this.handleChange = this.handleChange.bind(this);        
        this.autosize = this.autosize.bind(this);
        this.removeImage = this.removeImage.bind(this);
    }

    componentDidMount(){
        const {post, layout, edit} = this.props;
        if(edit && post && typeof layout.updateLayout === 'function')setTimeout(() => layout.updateLayout(), 500);
        document.addEventListener('trix-focus', (event:any) => { 
            event.target.toolbarElement.style.display = 'block';
            if(post && typeof layout.updateLayout === 'function')setTimeout(() => layout.updateLayout(), 500);
        });
        document.addEventListener('trix-blur', (event:any) => { 
            event.target.toolbarElement.style.display = 'none';
            if(post && typeof layout.updateLayout === 'function')setTimeout(() => layout.updateLayout(), 500);
        });
        if(post) this.setState({...this.state, _id:post?._id || '', postImage: post?.postImage || '', image: post?.postImage || '', layout:post?.layout || 1, title:post?.title || '', description:post?.description || '', isTruncated:post?.isTruncated || false});

        // Make title grow taller
        this.postTitleElement.current.addEventListener('input', this.autosize);
    }

    public autosize(e:any){      
       e.target.style.height = 'auto';
       e.target.style.height = `${e.target.scrollHeight}px`;
    }

    public routeLayout(): any {
        const { layout } = this.state;        
        switch (layout) {
            case 1:
                return this.titleMediaBody();
            case 2:
                return this.mediaTitleBody();
            default:
                return this.titleBodyMedia();
        }
    }

    public handleChange(html:any, text:any) {
        this.setState({...this.state, description: html});
    }

    public titleMediaBody() {       
        const {post, classes} = this.props; 
        const {  title, description } = post?post:this.state;
        const {removeImage} = this.state;
        let image:any = '';
        if(this.state.isNewImage && this.state.image !== '') { 
            image = this.state.image; 
        } else {
            image = post && !removeImage ? post.postImage: this.state.image;  
        }
        
        return (
            <div>
                <CardContent className="body-container-title">
                    <div className="textarea-comment-wrapper">
                        <div className="text-area">
                            <textarea
                                ref={this.postTitleElement}
                                autoFocus
                                className={classes.postTitle + ' new-post'}
                                onChange={this.inputHandleChange}
                                name="title"
                                onFocus={this.autosize}
                                maxLength={150}
                                placeholder="Title"
                                rows={1}
                                defaultValue={title || ''} />
                        </div>
                    </div>
                </CardContent>
                {image ? 
                    <div className={classes.imageHolder}>
                        <CardMedia className="image-bottom-gutter" component="img" alt="post image" image={image} title="Honor Wall Image" /> 
                        <Tooltip title={<p style={{fontSize: 14}}>remove image</p>}  className={classes.removeImage}><IconButton aria-label="Cancel" onClick={this.removeImage}><CancelIcon color="secondary" /></IconButton></Tooltip>
                    </div>
                : null}
                <CardContent className="text-editor-container">
                    <TrixEditor autoFocus={false} placeholder="Write a story..." onChange={this.handleChange} value={description}  />
                </CardContent>
            </div>
        );
    }

    public mediaTitleBody() {
        const {post, classes} = this.props;
        const {  title, description } = post?post:this.state;
        const {removeImage} = this.state;
        let image:any = '';
        if(this.state.isNewImage && this.state.image !== '') { image = this.state.image; }
        else {
            image = post && !removeImage ? post.postImage: this.state.image;  
        }
        return (
            <div>
                {image ? 
                    <div>
                        <CardMedia component="img" alt="post image" image={image} title="Honor Wall Image" />    
                        <Tooltip title={<p style={{fontSize: 14}}>remove image</p>}  className={classes.removeImage}><IconButton aria-label="Cancel" onClick={this.removeImage}><CancelIcon color="secondary" /></IconButton></Tooltip>                                 
                    </div> : null}
                <CardContent>
                    <div className="textarea-comment-wrapper">
                        <div className="text-area">
                            <textarea
                                autoFocus
                                className={classes.postTitle + ' new-post'}
                                onChange={this.inputHandleChange}                                
                                name="title"
                                rows={1}
                                maxLength={150}
                                placeholder="Title"
                                defaultValue={title || ''}></textarea>
                        </div>
                    </div>
                </CardContent>
                <CardContent className="text-editor-container">
                    <TrixEditor autoFocus={false} placeholder="Write a story..." onChange={this.handleChange} value={description}  />
                </CardContent>
            </div>
        );
    }

    public titleBodyMedia() {
        const {post, classes} = this.props;
        const {  title, description } = post?post:this.state;
        const {removeImage} = this.state;
        let image:any = '';
        if(this.state.isNewImage && this.state.image !== '') { image = this.state.image; }
        else {
            image = post && !removeImage ? post.postImage: this.state.image;  
        }
        return (
            <div>
                <CardContent className="body-container-title">
                    <div className="textarea-comment-wrapper">
                        <div className="text-area">
                            <textarea
                                autoFocus
                                className={classes.postTitle + ' new-post'}
                                onChange={this.inputHandleChange}
                                name="title"
                                rows={1}
                                maxLength={150}
                                placeholder="Title"
                                defaultValue={title || ''}></textarea>
                        </div>
                    </div>
                </CardContent>
                <CardContent className="text-editor-container">
                    <TrixEditor autoFocus={false} placeholder="Write a story..." onChange={this.handleChange}  value={description}  />
                </CardContent>
                {image ? 
                    <div>
                        <CardMedia component="img" alt="post image" image={image} title="Honor Wall Image" /> 
                        <Tooltip title={<p style={{fontSize: 14}}>remove image</p>}  className={classes.removeImage}><IconButton aria-label="Cancel" onClick={this.removeImage}><CancelIcon color="secondary" /></IconButton></Tooltip>
                    </div>
                    : null}
            </div>
        );
    }

    public uploadImage(e: any) {
        const {layout, edit} = this.props;
        const fileSizeLimit = 2000; // 2MB
        const fileReader = new FileReader();
        const fileSize = e.target.files[0].size;
        const fileKilobytes = Math.round((fileSize / 1000));        
        if (fileKilobytes > fileSizeLimit) {
             this.setState({ ...this.state, imageErrorMessage: true });
             return alert('Sorry, your image cannot exceed 2mb in file size. Please select a smaller sized image.');
        } 
        fileReader.readAsDataURL(e.target.files[0]);
        fileReader.onload = (e: any) => this.setState({ ...this.setState, image: e.target.result, isNewImage: true, removeImage: false });
        if(edit){ if (typeof layout.updateLayout === 'function') setTimeout(() => layout.updateLayout(), 500);}
    }

    public inputHandleChange(e: any) {
        const { name, value } = e.target
        this.setState({ ...this.state, [name]: value });
    }

    public layoutHandle() {
        const { layout } = this.state;
        const type = (layout === 1 || layout === 2) ? layout + 1 : 1;
        this.setState({ ...this.state, layout: type });
    }

    public uploadPostHandler() {
        const { title, description, layout, isTruncated, isNewImage, _id, image, postImage, removeImage } = this.state;
        const { addPost, tags, user, action, edit, updatePost, needsApproval, requiresUserContactInfo, contactForm, submitForm, /*dismissForm,*/ tagsRef, featuredTag } = this.props;
        
        /** This section is for the user contact form */
        if((requiresUserContactInfo === 'Yes' && !user.userInfo.userInfoSubmission) || (requiresUserContactInfo === 'Optional' && !user.userInfo.userInfoDismissed)){
            if(requiresUserContactInfo === 'Yes' && !contactForm.isValid) return alert('Oops! All fields with an asterisk are required. Please provide the missing information.'); 
            if((requiresUserContactInfo === 'Yes' || requiresUserContactInfo === 'Optional') && contactForm.isValid) submitForm(contactForm.user);
            if(requiresUserContactInfo === 'Optional' && !contactForm.isValid) submitForm(contactForm.user);// dismissForm(); submit it and catch anything
        }        
        /** This section is for the user contact form */

        const isApproved = (needsApproval) ? false: true;
        const userId = user.id;
        const userMetadata = { 
            type: 'user', 
            description: `post created by client wall app at ${window.location.href}`, 
            user: user, 
            contactRequired: requiresUserContactInfo,   
            location: window.location 
        };
        const post = { title, description, layout, tags, userId, isTruncated, userMetadata, _id, isNewImage, image, postImage, isApproved: isApproved, tagsRef, featuredTag, removeImage};

        edit ? updatePost(post) : addPost(post);
        action();
    }

    public truncateHandler() {
        this.setState({ ...this.state, isTruncated: !this.state.isTruncated });
    }

    public removeImage(){
        this.setState({...this.state, removeImage: true, image: null});
    }

    public render() {
        const { classes, action, needsApproval, requiresUserContactInfo, user, edit} = this.props;
        let showForm = false;
        if(requiresUserContactInfo === 'Yes' && !user.userInfo.userInfoSubmission) showForm = true;
        if(requiresUserContactInfo === 'Optional' && !user.userInfo.userInfoDismissed) showForm = true;
        
        // const { isTruncated } = this.state;        
        return (
            <Card className={classes.root}>
                {this.routeLayout()}
                {requiresUserContactInfo && showForm? <ContactInfo type={requiresUserContactInfo}/>:null}
                <CardActions className={classes.actionArea} >
                    <label htmlFor="upload-image-button"><Button component="span" arial-label="Add image" startIcon={<InsertPhotoIcon />} color="default" variant="outlined" size="small" className="upload-image-btn">Upload image</Button></label>
                    {/* <Tooltip title="Truncate description"><IconButton aria-label="Truncate" onClick={this.truncateHandler}> <UnfoldLessIcon color={isTruncated? 'primary': 'inherit'} /></IconButton></Tooltip>   */}
                    {/* <Tooltip title="Post Layout"><IconButton aria-label="post layout" onClick={this.layoutHandle}> <ViewComfyIcon /></IconButton></Tooltip> */}
                    <Tooltip open={false} title={<p style={{fontSize: 14}}>Post memory</p>} className={classes.uploadIcon}><Button aria-label="Post story" onClick={this.uploadPostHandler} color="primary" variant="outlined" size="large" className={classes.postStoryBtn}>Post Story</Button></Tooltip>
                    <Tooltip title={<p style={{fontSize: 14}}>Cancel</p>}  className={edit? classes.cancelIconPost: classes.cancelIcon}><IconButton aria-label="Cancel" onClick={action}><CancelIcon color="secondary" /></IconButton></Tooltip>
                </CardActions>
                <input style={{ display: 'none' }} accept="image/*" className={classes.input} id="upload-image-button" multiple type="file" onChange={this.uploadImage} />
                {needsApproval? <p className="approval-text">The story will be reviewed and approved in the next 48hrs.</p>:null}
            </Card>
        );
    }
}
const mapProps = (app: any) => ({ posts: app.rootReducer.posts, user: app.rootReducer.user, contactForm: app.rootReducer.contactForm});
const mapDisptach = (dispatch: Dispatch) => ({
    addPost: (data: any) => dispatch({ type: ADD_POST, payload: data }),
    updatePost: (data: any) => dispatch({ type: UPDATE_POST, payload: data }),
    deletePost: (postId: string) => dispatch({ type: REMOVE_POST, payload: postId }),
    getPost: (id: any, posts: any) => posts.find((post: IPost) => post._id === id) || false,
    dismissForm: () => dispatch({type: USER_INFO_FORM_DISMISSED}),
    submitForm: (data:any) => dispatch({type: USER_INFO_FORM_SUBMISSION, payload: data})
});
export default connect(mapProps, mapDisptach)(withStyles(styles)(PostAddEdit));